import { timer } from 'rxjs'; 
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent {

  roles: any[] = [];
  searchTerm: string = '';
  originalRoles: any[] = [];
  loading: boolean = true;
  mensajeRoles: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.verificacionUsuario();  
  }
  verificacionUsuario(){
    this.navigationService.disableNavigation();
    const token = String(localStorage.getItem('token1'))
    timer(0).subscribe(() => {
      this.requestsService.getAllRol(token).subscribe(
        (data: any) => {
          data.length === 0 ? this.mensajeError('No se tienen roles que mostrar.') : this.roles = data;
          this.originalRoles = data;
          this.loading = false;
      });
    });
  }

  search() {
    if (this.searchTerm) {
      this.buscador();    
    } else {
      this.roles = this.originalRoles;
    }
  }
  
  buscador(){
    this.roles = this.originalRoles.filter(roles => {
      return roles.Rls_Nombre.toLowerCase().includes(this.searchTerm.toLowerCase())
    });
    this.roles.length === 0 && this.mensajeError(`Con los criterios ${this.searchTerm}, no encontramos ninguna coincidencia.`);
  }

  mensajeError(mensaje:string){
    this.mensajeRoles = mensaje;
  }
  
  editar(op: any, rol: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(rol);
    this.router.navigate(['/rolesD', opE]);
  }
  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/rolesD', opE]);
  }
}